<template>
  <section :class="$style.container">
    <DolphinCheckbox
      :class="[$style.container__checkbox, $style.checkbox]"
      :modelValue="checked"
      @update:model-value="checked => emit('changeCheck', checked)"
    />
    <RouterLink
      :to="attackListSenderSettingUpdateHref(setting.id)"
      :class="[$style.container__content, $style.content]"
    >
      <div :class="$style.content__condition">
        <StateChip
          :text="setting.isEnabled ? '有効' : '無効'"
          :variation="setting.isEnabled ? 'positive' : 'negative'"
        />
        <p :class="[$style.content__text, $style.text]">
          {{ setting.title }}
        </p>
      </div>
      <p :class="[$style.content__plannerName, $style.plannerName]">
        プランナー名: {{ setting.entrance.name }}
      </p>
    </RouterLink>
  </section>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

import DolphinCheckbox from '@/components/atoms/DolphinCheckbox.vue'
import StateChip from '@/components/atoms/StateChip.vue'
import { useEntranceGUIDParam } from '@/features/entrance/useEntranceGUIDParam'

import type { SettingsPageAttackListSenderViewSettingItemAttackListSenderSettingFragment } from './SettingsPageAttackListSenderViewSettingItem.generated'

defineProps<{
  setting: SettingsPageAttackListSenderViewSettingItemAttackListSenderSettingFragment
  checked: boolean
}>()

const emit = defineEmits<{
  (event: 'changeCheck', checked: boolean): void
}>()

const { entranceGUID } = useEntranceGUIDParam({ must: false })

const attackListSenderSettingUpdateHref = (id: string): RouteLocationRaw => ({
  name: 'attackListSenderSettingUpdate',
  params: {
    entranceGUID: entranceGUID.value,
    attackListSenderSettingId: id,
  },
})
</script>

<style lang="scss" module>
.container {
  border: 1px solid $color-border-low-emphasis;
  border-radius: $border-radius-v2-base;
  display: flex;
  align-items: center;

  &__checkbox {
    margin-left: 16px;
    position: absolute;
  }

  &:hover {
    background-color: $color-surface-accent-primary-light;
  }
}

.content {
  display: flex;
  flex: 1;
  padding: 16px 16px 16px 56px;
  justify-content: space-between;

  &__condition {
    display: flex;
    gap: 16px;
  }

  &:hover {
    text-decoration: none;
  }
}

.text {
  font-weight: bold;
}

.plannerName {
  color: $color-text-and-object-high-emphasis;
}
</style>
